import Vue from 'vue';
const EventBus = new Vue();

const addListener = (event, listener) => {
  EventBus.$on(event, listener)
}

const removeListener = (event, listener) =>{
  EventBus.$off(event, listener)
}

const emit = (event, payload) => {
  EventBus.$emit(event, payload);
}

export default {
  addListener,
  removeListener,
  emit
}
